export default {
  bulkOptions: [
    {
      key: 'delete_bulk',
      field: 'delete_bulk',
      value: 'true',
      label: 'Delete',
      type: 'danger',
      permissionCode: 'geo.delete_province',
    },
  ],
  exportImportOptions: {
    export: {
      directly: true,
      url_name: 'api:admin:geo:province:export',
    },
  },
}